(function () {
  window.__ecwGiftConfig = window.__ecwGiftConfig || {};
  window.__ecwLastBundleCartAdd = 0;

  var MIN_GIFT_QTY = 3;

  function isGiftEligibleQty(qty) {
    return (parseInt(qty, 10) || 0) >= MIN_GIFT_QTY;
  }

  var GIFT_REMOVAL_GRACE_MS = 5000;

  function getGiftProps() {
    var cfg = window.__ecwGiftConfig;
    return {
      key: cfg.giftPropertyKey || 'Wasserdichte Tasche',
      value: cfg.giftPropertyValue || 'Gratis'
    };
  }

  function getFormGiftField(form, name) {
    if (!form) return '';
    var el = form.querySelector('[name="' + name + '"]');
    if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    if (form.id) {
      el = document.querySelector('[name="' + name + '"][form="' + form.id + '"]');
      if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    }
    return '';
  }

  function collectFormProperties(formData) {
    var props = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = value;
    });
    return props;
  }

  function getGiftColorForForm(form) {
    var color = getFormGiftField(form, 'properties[_bundle_gift_color]').toLowerCase();
    if (color === 'white' || color === 'black') return color;
    return 'black';
  }

  function getGiftVariantIdForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteVariantId || null;
    return cfg.blackVariantId || null;
  }

  async function resolveGiftVariantId(color) {
    var cached = getGiftVariantIdForColor(color);
    if (cached) return cached;

    var handle = getGiftHandleForColor(color);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      var response = await fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' });
      if (!response.ok) return null;
      var product = await response.json();
      if (!product || !product.variants || !product.variants.length) return null;
      var variantId = product.variants[0].id;
      if (color === 'white') window.__ecwGiftConfig.whiteVariantId = variantId;
      else window.__ecwGiftConfig.blackVariantId = variantId;
      return variantId;
    } catch (err) {
      return null;
    }
  }

  function getGiftHandleForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteHandle || 'gratis-oko-wet-bag-weiss-regalo';
    return cfg.blackHandle || 'gratis-oko-wet-bag-schwarz-regalo';
  }

  window.__ecwShouldAddBundleGift = function (form) {
    if (!form) return false;
    if (getFormGiftField(form, 'properties[_bundle_gift_eligible]') !== 'true') return false;
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    return isGiftEligibleQty(packQty);
  };

  window.__ecwMarkCartAdd = function () {
    window.__ecwLastBundleCartAdd = Date.now();
  };

  window.__ecwRecentlyAddedBundle = function () {
    return Date.now() - (window.__ecwLastBundleCartAdd || 0) < GIFT_REMOVAL_GRACE_MS;
  };

  window.__ecwFetchCartSections = async function (cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') return {};
    var ids = cartComponent.getSectionsToRender().map(function (section) {
      return section.id;
    });
    if (!ids.length) return {};
    var url = window.location.pathname + '?sections=' + ids.join(',');
    var response = await fetch(url, { credentials: 'same-origin' });
    return response.json();
  };

  window.__ecwRefreshCartDrawer = async function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var response = await fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' });
    var htmlText = await response.text();
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');

    ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
      var target = document.querySelector(selector);
      var source = doc.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });

    var newDrawer = doc.querySelector('cart-drawer');
    var currentDrawer = document.querySelector('cart-drawer');
    if (newDrawer && currentDrawer) {
      currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    }

    var emptyEl = document.querySelector('.drawer__inner-empty');
    if (emptyEl && newDrawer && !newDrawer.classList.contains('is-empty')) {
      emptyEl.remove();
    }
    if (currentDrawer && newDrawer && !newDrawer.classList.contains('is-empty')) {
      currentDrawer.classList.remove('is-empty');
    }

    if (typeof window.__ecwFetchCartSections === 'function') {
      var bubbleData = await fetch(window.location.pathname + '?sections=cart-icon-bubble', {
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).catch(function () { return {}; });

      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl && bubbleData['cart-icon-bubble']) {
        var parsed = new DOMParser().parseFromString(bubbleData['cart-icon-bubble'], 'text/html');
        var inner = parsed.querySelector('.shopify-section');
        if (inner) bubbleEl.innerHTML = inner.innerHTML;
      }
    }
  };

  window.__ecwAddBundleProductAndGift = async function (form) {
    if (!window.__ecwShouldAddBundleGift(form)) return null;

    window.__ecwMarkCartAdd();

    var formData = new FormData(form);
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    var variantId = formData.get('id');
    if (!variantId) return { error: { description: 'Variant not found' } };

    var properties = collectFormProperties(formData);
    var color = getGiftColorForForm(form);
    var giftVariantId = await resolveGiftVariantId(color);
    var giftHandle = getGiftHandleForColor(color);
    var giftProps = getGiftProps();
    var giftLineProps = { '_bundle_gift_auto': 'true' };
    giftLineProps[giftProps.key] = giftProps.value;

    properties._bundle_gift_eligible = 'true';
    properties._bundle_gift_color = color;
    properties._bundle_gift_qty = String(packQty);

    var items = [{
      id: Number(variantId),
      quantity: packQty,
      properties: properties
    }];

    if (giftVariantId) {
      items.push({
        id: Number(giftVariantId),
        quantity: 1,
        properties: giftLineProps
      });
    }

    var addRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });

    if (addRes.status) return { error: addRes };

    if (giftVariantId) {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var hasGift = cart.items.some(function (item) {
        return item.handle === giftHandle || window.__ecwIsBundleGiftItem(item);
      });

      if (!hasGift) {
        var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: Number(giftVariantId), quantity: 1, properties: giftLineProps }]
          })
        }).then(function (r) { return r.json(); });

        if (giftRes.status) {
          console.error('Gift bag not added:', giftRes.description || giftRes.message);
        }
      }
    }

    window.__ecwMarkCartAdd();

    return { ok: true, variantId: variantId };
  };

  function isBundleGiftHandle(handle) {
    var cfg = window.__ecwGiftConfig || {};
    return handle === (cfg.whiteHandle || 'gratis-oko-wet-bag-weiss-regalo') ||
      handle === (cfg.blackHandle || 'gratis-oko-wet-bag-schwarz-regalo');
  }

  function isPadCartItem(item) {
    if (!item) return false;
    var handle = (item.handle || '').toLowerCase();
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    var cfg = window.__ecwGiftConfig || {};
    var padHandles = cfg.padHandles || [];

    if (padHandles.indexOf(handle) !== -1) return true;

    return handle.indexOf('waschbare') !== -1 ||
      handle.indexOf('binden') !== -1 ||
      handle.indexOf('slipeinlage') !== -1 ||
      handle.indexOf('wiederverwendbar') !== -1 ||
      title.indexOf('binden') !== -1 ||
      title.indexOf('slipeinlage') !== -1 ||
      title.indexOf('waschbare') !== -1 ||
      title.indexOf('wiederverwendbar') !== -1;
  }

  window.__ecwIsBundleGiftItem = function (item) {
    if (!item) return false;
    if (isBundleGiftHandle(item.handle)) return true;
    if (item.properties && item.properties._bundle_gift_auto != null &&
      String(item.properties._bundle_gift_auto).trim() !== '') return true;
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    return (parseInt(item.final_price, 10) || 0) === 0 &&
      (title.indexOf('wet bag') !== -1 || title.indexOf('wet-bag') !== -1 ||
        title.indexOf('oko-wet-bag') !== -1 ||
        title.indexOf('tasche') !== -1 ||
        (title.indexOf('regalo') !== -1 && (title.indexOf('bag') !== -1 || title.indexOf('tasche') !== -1)));
  };

  function getPadLineItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return item && !window.__ecwIsBundleGiftItem(item) && isPadCartItem(item);
    });
  }

  function getPadPackSizeFromItem(item) {
    if (!item) return 1;

    var textParts = [
      item.variant_title,
      item.title,
      item.product_title
    ];

    if (item.options_with_values && item.options_with_values.length) {
      item.options_with_values.forEach(function (opt) {
        if (opt && opt.value) textParts.push(opt.value);
      });
    }

    var text = textParts.filter(Boolean).join(' ').toLowerCase();
    if (!text) return 1;

    var match = text.match(/(\d+)\s*er[\s-]*pack/);
    if (match) return parseInt(match[1], 10) || 1;

    match = text.match(/(\d+)\s*[- ]?\s*pack/);
    if (match) return parseInt(match[1], 10) || 1;

    match = text.match(/pack(?:ung)?\s*(?:mit|de|of)?\s*(\d+)/);
    if (match) return parseInt(match[1], 10) || 1;

    match = text.match(/(\d+)\s*(?:x|stück|stk|units?)/);
    if (match) return parseInt(match[1], 10) || 1;

    return 1;
  }

  function getPadItemEffectiveQty(item) {
    var lineQty = parseInt(item.quantity, 10) || 0;
    return lineQty * getPadPackSizeFromItem(item);
  }

  window.__ecwGetPadItemEffectiveQty = getPadItemEffectiveQty;

  function getTotalPadQty(cart) {
    return getPadLineItems(cart).reduce(function (total, item) {
      return total + getPadItemEffectiveQty(item);
    }, 0);
  }

  function getGiftColorForPadItem(item) {
    var color = 'black';
    var handle = (item.handle || '').toLowerCase();
    var colorProp = item.properties && item.properties._bundle_gift_color
      ? String(item.properties._bundle_gift_color).toLowerCase()
      : '';
    if (colorProp === 'white' || colorProp === 'black') {
      color = colorProp;
    } else if (handle.indexOf('weiss') !== -1 || handle.indexOf('weiß') !== -1 ||
      handle.indexOf('white') !== -1 || handle.indexOf('blanco') !== -1) {
      color = 'white';
    } else if (handle.indexOf('schwarz') !== -1 || handle.indexOf('black') !== -1 ||
      handle.indexOf('negro') !== -1 || handle.indexOf('starker-durchfluss') !== -1 ||
      handle.indexOf('night') !== -1 || handle.indexOf('nacht') !== -1) {
      color = 'black';
    }
    return color;
  }

  window.__ecwGetTotalPadQty = getTotalPadQty;

  window.__ecwIsCartGiftEligible = function (cart) {
    return getTotalPadQty(cart) >= MIN_GIFT_QTY;
  };

  window.__ecwHasEligiblePackLine = function (cart) {
    return window.__ecwIsCartGiftEligible(cart);
  };

  window.__ecwGetDesiredGiftColor = function (cart) {
    var padItems = getPadLineItems(cart);
    if (!padItems.length) return 'black';
    padItems.sort(function (a, b) {
      return getPadItemEffectiveQty(b) - getPadItemEffectiveQty(a);
    });
    return getGiftColorForPadItem(padItems[0]);
  };

  window.__ecwRemoveOrphanGifts = async function (cartOptional) {
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    if (window.__ecwIsCartGiftEligible(cart)) return false;

    return window.__ecwRemoveAllGiftsFromCart(cart);
  };

  window.__ecwRemoveAllGiftsFromCart = async function (cartOptional) {
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    var updates = {};
    cart.items.forEach(function (item) {
      if (window.__ecwIsBundleGiftItem(item)) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });

    if (typeof window.__ecwRefreshCartDrawer === 'function') {
      await window.__ecwRefreshCartDrawer();
    }

    return true;
  };

  window.__ecwSyncGiftBagForCart = async function () {
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var totalPads = getTotalPadQty(cart);

    if (totalPads < MIN_GIFT_QTY) {
      return window.__ecwRemoveAllGiftsFromCart(cart);
    }

    var padItems = getPadLineItems(cart);
    if (!padItems.length) return false;

    padItems.sort(function (a, b) {
      return getPadItemEffectiveQty(b) - getPadItemEffectiveQty(a);
    });

    var color = getGiftColorForPadItem(padItems[0]);
    var desiredHandle = getGiftHandleForColor(color);
    var desiredVariantId = await resolveGiftVariantId(color);
    if (!desiredHandle || !desiredVariantId) return false;

    var giftItems = cart.items.filter(function (item) {
      return window.__ecwIsBundleGiftItem(item);
    });
    var correctGift = giftItems.filter(function (item) {
      return item.handle === desiredHandle;
    });
    var wrongGifts = giftItems.filter(function (item) {
      return item.handle !== desiredHandle;
    });

    var updates = {};
    wrongGifts.forEach(function (item) {
      updates[item.key] = 0;
    });

    if (correctGift.length > 1) {
      var kept = false;
      correctGift.forEach(function (item) {
        if (!kept) {
          if ((parseInt(item.quantity, 10) || 0) !== 1) updates[item.key] = 1;
          kept = true;
        } else {
          updates[item.key] = 0;
        }
      });
    } else if (correctGift.length === 1) {
      var onlyGift = correctGift[0];
      if ((parseInt(onlyGift.quantity, 10) || 0) !== 1) {
        updates[onlyGift.key] = 1;
      }
    }

    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      });
    }

    if (correctGift.length === 0) {
      var giftProps = getGiftProps();
      var giftLineProps = { '_bundle_gift_auto': 'true' };
      giftLineProps[giftProps.key] = giftProps.value;

      var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: Number(desiredVariantId),
            quantity: 1,
            properties: giftLineProps
          }]
        })
      }).then(function (r) { return r.json(); });

      if (giftRes.status) return false;
    }

    if (Object.keys(updates).length > 0 || correctGift.length === 0) {
      if (typeof window.__ecwRefreshCartDrawer === 'function') {
        await window.__ecwRefreshCartDrawer();
      }
      return true;
    }

    return false;
  };

  window.__ecwEnsureGiftForCart = async function () {
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    if (getTotalPadQty(cart) < MIN_GIFT_QTY) return false;

    var padItems = getPadLineItems(cart);
    if (!padItems.length) return false;

    padItems.sort(function (a, b) {
      return getPadItemEffectiveQty(b) - getPadItemEffectiveQty(a);
    });

    var giftProps = getGiftProps();
    var giftLineProps = { '_bundle_gift_auto': 'true' };
    giftLineProps[giftProps.key] = giftProps.value;

    var color = getGiftColorForPadItem(padItems[0]);
    var desiredHandle = getGiftHandleForColor(color);
    var desiredVariantId = await resolveGiftVariantId(color);
    if (!desiredHandle || !desiredVariantId) return false;

    var hasGift = cart.items.some(function (item) {
      return item.handle === desiredHandle || window.__ecwIsBundleGiftItem(item);
    });
    if (hasGift) return false;

    var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(desiredVariantId),
          quantity: 1,
          properties: giftLineProps
        }]
      })
    }).then(function (r) { return r.json(); });

    return !giftRes.status;
  };
})();
